import Vue from 'vue';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import App from './App.vue';
import { routes } from './routes.js';
import { store } from './store';

Vue.use(VueResource);
Vue.use(VueRouter);

Vue.filter('capitalize', (value) => {
    if (!value) {
        return '';
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      const narrowView = window.getComputedStyle(document.getElementById('eurus-image')).display === 'none';
      let defaultXY;
      if (narrowView) {
        const sidebarEl = document.getElementById('sidebar');
        const sidebarElRect = sidebarEl.getBoundingClientRect();
        console.log("sidebarElRect=", sidebarElRect, sidebarEl.scrollHeight);
        defaultXY = {
          x: sidebarElRect.left,
          y: sidebarElRect.height
        }
      }
      else {
        defaultXY = {
          x: 0,
          y: 0
        }
      }
      if (from && from.path && from.path.indexOf('/listings/') === 0) {
        return defaultXY;
      }
      if (to && to.path && to.path.indexOf('/listing/') === 0) {
        if (to.path.indexOf('/detail') > 0 ||
          to.path.indexOf('/map') > 0 ||
          to.path.indexOf('/schools') > 0 ||
          to.path.indexOf('/communityinfo') > 0) {
          if (narrowView) {
            return defaultXY;
          }
          return savedPosition;
        }
      }
      return defaultXY;
    }
});

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js